export default "__VITE_ASSET__mBDbvZK7__"